import { render, staticRenderFns } from "./mdc-typo-button.vue?vue&type=template&id=57c635e1&"
import script from "./mdc-typo-button.vue?vue&type=script&lang=ts&"
export * from "./mdc-typo-button.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports